var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(
      _vm.user.personalInfo &&
      (_vm.user.personalInfo.personalId ||
        _vm.user.personalInfo.email ||
        _vm.user.personalInfo.cellphone)
    )?_c('button',{staticClass:"button is-light",attrs:{"slot":"trigger"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('open-user-info-modal', _vm.user)}},slot:"trigger"},[_vm._v(" "+_vm._s(`${_vm.user.personalInfo.name} ${_vm.user.personalInfo.surname}`)+" ")]):_c('p',[_vm._v(" "+_vm._s(_vm.user._id)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }